import Permission from '@/modules/authorization/model/Permission'
import {Module} from 'vuex'
import {RootState} from '@/store/types'
import mutations from '@/modules/authorization/store/mutations'
import actions from '@/modules/authorization/store/actions'
import getters from '@/modules/authorization/store/getters'
import Role from '@/modules/authorization/model/Role';
import Pagination from '@/modules/core/model/pagination';
import RoleUserAssignation from '@/modules/authorization/model/RoleUserAssignation';
import {RejectionDetails} from '@/modules/reservation/model/CreateListResult';

export interface AuthorizationState {
    /**
     * Árbol de permisos de la aplicación
     */
    permissions: Permission

    /**
     * Permission actualmente seleccionado por el usuario
     */
    permission: Permission

    /**
     * Indica si el usuario esta editando un permiso existente o creando uno
     * nuevo.
     */
    editingPermission: boolean,

    /**
     * Árbol de roles de usuario registrados en la aplicación
     */
    roles: Role,

    /**
     * Rol de usuario actualmente editado por el usuario
     */
    role: Role,

    /**
     * Indica si el usuario esta editando un rol o creando uno nuevo
     */
    editingRole: boolean,

    /**
     * Lista actual de usuario asignados a un rol
     */
    roleUserAssignationList: Pagination<RoleUserAssignation>,

    updatedRoleUserAssignationList: RoleUserAssignation[],

    /**
     * Permisos habilitados para el usuario
     */
    grantedPermissions: string[],

    /**
     * Permisos rechazado para el usuario
     */
    rejectedPermissions: Array<{path: string, rejectionMessage: string}>,
}

const module: Module<AuthorizationState, RootState> = {
    namespaced: true,
    actions,
    mutations,
    getters,
    state: {
        // Estado de permisos
        permissions: new Permission(),
        permission: new Permission(),
        editingPermission: false,
        // Estado de roles
        roles: new Role(),
        role: new Role(),
        editingRole: false,
        roleUserAssignationList: {
            totalPages: 0,
            totalRecords: 0,
            items: [],
        },
        updatedRoleUserAssignationList: [],
        grantedPermissions: [],
        rejectedPermissions: [],
    },
}

export default module
